import { gql } from "@apollo/client/core";
import Document_User from '../Document/Document_User'

export default gql`
    ${Document_User}
    fragment Fleet_Documents on Fleet {
        id
        documents {
            ...Document_User
        }
    }
`
